import { __decorate } from "tslib";
import { Mixins, Component, Prop, Watch } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import ActionButton from '@/components/action_button/Index.vue';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import DiyMixin from '@/helpers/vue_mixins/v2/DiyMixin';
import FormHeader from '@/components/v2/FormHeader.vue';
import FormHeaderMixin from '@/helpers/vue_mixins/v2/FormHeaderMixin';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import TheDiyActions from '@/components/v2/diy/TheDiyActions.vue';
import { Getter } from 'vuex-class';
import { required, requiredIf, url } from 'vuelidate/lib/validators';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import Modal from '@/components/v3/Modal.vue';
let ShopifySettingsForm = class ShopifySettingsForm extends Mixins(validationMixin, DiyMixin, FormHeaderMixin, FormValidationsMixin, ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.apiCredentialsDialog = false;
        this.apiPermissionDialog = false;
        this.apiSetupDialog = false;
        this.form = {
            apiKey: null,
            apiPassword: null,
            apiVersion: null,
            accessToken: null,
            shopifyStoreDomain: null,
        };
    }
    get shopifyInstructionNumberFour() {
        return require('@/assets/images/shopify_instruction_4.png');
    }
    get shopifyInstructionNumberFive() {
        return require('@/assets/images/shopify_instruction_5.png');
    }
    get shopifyInstructionNumberSix() {
        return require('@/assets/images/shopify_instruction_6.png');
    }
    get youtubeIcon() {
        return require('@/assets/icons/youtube.svg');
    }
    formDataObserver(newValue) {
        this.form = { ...this.form, ...newValue };
    }
    onSubmit() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
            // Trim all input values before submission
            const trimmedForm = {};
            Object.entries(this.form).forEach(([key, value]) => {
                trimmedForm[key] = value ? value.trim() : null;
            });
            // Use the trimmed values after trimming
            const { accessToken, apiKey, apiPassword, ...otherValues } = trimmedForm;
            this.$emit('submit', {
                accessToken: accessToken || null,
                apiKey: apiKey || null,
                apiPassword: apiPassword || null,
                ...otherValues,
            });
        }
    }
};
__decorate([
    Getter('requestOnFlight')
], ShopifySettingsForm.prototype, "requestCurrentlyOnFlight", void 0);
__decorate([
    Prop({ type: Object, default: null })
], ShopifySettingsForm.prototype, "formData", void 0);
__decorate([
    Prop({ type: String, default: null })
], ShopifySettingsForm.prototype, "uuid", void 0);
__decorate([
    Watch('formData')
], ShopifySettingsForm.prototype, "formDataObserver", null);
ShopifySettingsForm = __decorate([
    Component({
        components: {
            ActionButton,
            BaseTextField,
            FormHeader,
            TheDiyActions,
            Modal,
        },
        validations() {
            const vm = this;
            const isDiy = () => vm.diy && !vm.uuid;
            const isExisting = () => {
                return !!vm.uuid && !vm.form.accessToken;
            };
            return {
                form: {
                    apiKey: { required: requiredIf(isExisting) },
                    apiVersion: { required },
                    apiPassword: { required: requiredIf(isExisting) },
                    accessToken: { required },
                    shopifyStoreDomain: {
                        required,
                        url,
                    },
                },
            };
        },
    })
], ShopifySettingsForm);
export default ShopifySettingsForm;
